export const CAMPAIGN = {
  TITLE: 'Ad Campaigns',
  LOADING: 'Loading Campaigns',
  SEARCH: 'Search by Campaign ID / Name / Tags / URL',
  ADD_BUTTON: 'Add Campaign',
};
